module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-header"
  }, [_c('h2', {
    staticClass: "profile-header__title"
  }, [_vm._t("default")], 2), (_vm.$slots.subtitle) ? _c('p', {
    staticClass: "profile-header__subtitle"
  }, [_vm._t("subtitle")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1acf380e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/header/Header.vue
// module id = bd301910af026c60c2c9
// module chunks = 89